/**
 * Portal session inactivity windows offered in Client Config (DIS-1762).
 *
 * A fixed list rather than a free numeric input: the values are mirrored by an
 * `s/enum` in the rn-v3 config service, which is the only enforcement that a
 * user cannot bypass.
 *
 * The 15 minute floor is not a preference. The session warning modal uses a
 * fixed five minute lead time before expiry, so a shorter window would leave it
 * permanently on screen. 120 minutes matches the current platform default, so
 * this setting can only shorten a client's window, never lengthen it.
 *
 * `PLATFORM_DEFAULT` maps to null, which is how a client expresses "no
 * override" — rn-portal then falls back to the platform-wide value.
 */
export const SessionTimeoutIntervals = {
  PLATFORM_DEFAULT: {
    label: 'Platform default (2 hours)',
    value: null as number | null,
  },
  _15MINUTES: {
    label: '15 minutes',
    value: 15,
  },
  _30MINUTES: {
    label: '30 minutes',
    value: 30,
  },
  _1HOUR: {
    label: '1 hour',
    value: 60,
  },
  _2HOURS: {
    label: '2 hours',
    value: 120,
  },
};
